import { get } from '../client';

export const activityLogsApi = {
  list: (params) => get('/activity-logs', { params }),
};
